import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 24px;
    height: 24px;
    flex-shrink: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 100%;
        height: 100%;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 22px;
        height: 22px;
    }
`;
